import {Href, useNavigation, useRouter} from "expo-router";
import {Platform} from "react-native";

// workaround messy expo-router + Android + cross-tab navigation
//
// expo-router navigates to the screen and _then_ switches the tab,
// causing us to land on the initial top-level page.
export default function useCrossTabNavigation() {
    const router = useRouter();
    const navigation = useNavigation();

    function navigate(href: Href) {
        if (Platform.OS === "android") {
            const prefix = navigation.getId();
            if (prefix === undefined || !(href.toString().startsWith(prefix))) {
                router.navigate(href);
                setTimeout(() => router.push(href), 500);
                return;
            }
        }
        router.push(href);
    }

    return {navigate}
}
